import { cn } from "@/lib/utils";

const HEIGHT = {
  /** Explore: behind a full hero (title, copy, search pill). */
  lg: "h-[460px]",
  /** Feed, Compare, org story: behind a greeting/title line or a header card. */
  sm: "h-[300px]",
} as const;

/**
 * Bright UI: a soft teal wash across the full width of a page's content area,
 * fading to the canvas. Place it as the first child of a `relative` scroll
 * container (and give the content after it `relative` so it paints above);
 * it sits behind the page content and scrolls with it.
 */
export default function PageBand({ size = "lg", className }: { size?: keyof typeof HEIGHT; className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-x-0 top-0 bg-gradient-to-b from-teal-tint/70 via-teal-tint/25 to-transparent",
        HEIGHT[size],
        className,
      )}
    />
  );
}
